/**
 * Created by staffanrantzow on 01/12/16.
 */

export default class AgreementDraftEntity {

  constructor (
    id,
    headline,
    languageId,
    text,
    typeId
  ) {
    this.id = id;
    this.headline = headline;
    this.languageId = languageId;
    this.text = text;
    this.typeId = typeId;
  }

}



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/agreement-drafts/agreement-draft-entity.js
 **/